module.exports = __webpack_public_path__ + "img/logo.2faaba39.svg";